import * as yup from 'yup';
import { isDigitsOnly, isBelowLength } from '@shared/lib/validators';
import { phoneNumberSchema } from '../../../lib/phoneValidation';

export const MEMBERSHIP_SELECTION_REQUIRED_MESSAGE = 'For å fortsette, ber vi deg ta et valg her.';

export const createHolderSchema = (isMembershipSelectionRequired = false) =>
  yup.object().shape({
    membershipSelection: isMembershipSelectionRequired
      ? yup.string().required(MEMBERSHIP_SELECTION_REQUIRED_MESSAGE)
      : yup.string(),
    firstName: yup.string().required('Vennligst fyll inn dette feltet.'),
    lastName: yup
      .string()
      .test('Lengde', 'Må være kortere enn 50 tegn', isBelowLength(50))
      .required('Vennligst fyll inn dette feltet.'),
    eMail: yup.string().required('Vennligst fyll inn dette feltet.'),
    phoneNumber: phoneNumberSchema({ required: true }),
    birthDate: yup
      .object()
      .shape({
        day: yup.number().min(1, 'For lavt').max(31, 'For høyt').required('Dato').typeError('Bruk tall'),
        month: yup.number().min(1, 'For lavt').max(12, 'For høyt').required('Måned').typeError('Bruk tall'),
        year: yup.number().min(1753, 'Det var tidlig..').required('År').typeError('Bruk tall'),
      })
      .typeError('Vennligst fyll inn dette feltet.'),
    address: yup.string().required('Vennligst fyll inn dette feltet.'),
    zip: yup
      .string()
      .required('Vennligst fyll inn dette feltet.')
      .length(4, 'Dette er ikke et gyldig postnummer')
      .test('Kun tall', 'Feltet kan kun inneholde tall', isDigitsOnly),
    cityOfBirth: yup.string().required('Vennligst fyll inn dette feltet.'),
    countryOfBirth: yup.string().required('Vennligst fyll inn dette feltet.'),
  });

export const HolderSchema = createHolderSchema();
